export enum ReadingType {
  default = 0,
  heating = 1,
}
